function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import styled from 'styled-components';
import { withSpacing } from '../lib/hoc/withSpacing';
import { themify } from '../styles/mixins';
import { RadioLabel, StyledRadio } from './Radio';
const StyledCheckbox = styled(StyledRadio).withConfig({
  displayName: "Checkbox__StyledCheckbox",
  componentId: "sc-14reiz7-0"
})([""]);
const CheckboxLabel = styled(RadioLabel).withConfig({
  displayName: "Checkbox__CheckboxLabel",
  componentId: "sc-14reiz7-1"
})(["&::before{border-radius:2px;}"]);

const CheckboxFunc = (_ref) => {
  let {
    bgColor = 'green',
    borderColor = 'gray',
    className,
    color = 'grayDarker',
    disabled,
    fontSize = 5,
    id,
    itemKey,
    label,
    mobile,
    onChange,
    value,
    width = 'auto'
  } = _ref,
      rest = _objectWithoutProperties(_ref, ["bgColor", "borderColor", "className", "color", "disabled", "fontSize", "id", "itemKey", "label", "mobile", "onChange", "value", "width"]);

  return /*#__PURE__*/React.createElement(React.Fragment, {
    key: itemKey
  }, /*#__PURE__*/React.createElement(StyledCheckbox, _extends({
    $bgColor: themify(bgColor),
    disabled: disabled,
    id: id,
    onChange: disabled ? undefined : () => onChange(value),
    type: "checkbox",
    value: value
  }, rest)), /*#__PURE__*/React.createElement(CheckboxLabel, {
    $bgColor: themify(bgColor),
    $borderColor: themify(borderColor),
    $color: themify(color),
    $fontSize: fontSize,
    $mobile: mobile,
    $width: width,
    className: className,
    htmlFor: id,
    title: rest.title
  }, label));
};

CheckboxFunc.displayName = 'Checkbox';
export const Checkbox = withSpacing(CheckboxFunc, {
  mr: 1,
  mb: 1
});